<p-table
  #pt
  [value]="rateProfiles"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25,100,200]"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  [totalRecords]="recordTotal"
  [responsive]="true"
  sortMode="multiple"
  selectionMode="single"
  [(selection)]="rateProfile"
  dataKey="rateProfileId"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"> <ng-template pTemplate="caption"> <i
  class="fa fa-search"
style="margin:4px 4px 0 0;"></i> <!-- <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')" style="width:auto;"> -->
<div class="d-block text-end">
  <span>
    <!--clear filters-->
    <button pButton pRipple class="p-button-text"
      style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
    (click)="reloadPage()">Clear Filters</button>

    <!--add new-->
    <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
    routerLink="/rate-profile-add">New Rate Profile +</button>
  </span>
</div>
</ng-template> <ng-template pTemplate="header">
<tr>
  @for (col of columns; track col) {
    <th
      [pSortableColumn]="col.field">{{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
    </th>
  }
</tr>
<tr>
  @for (col of columns; track col) {
    <th
      >
      @switch (col.field) {@case ('rateProfileId') {
        <input
          pInputText
          type="number"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('startDate') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('endDate') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        }}
      </th>
    }
  </tr>
</ng-template> <ng-template
pTemplate="body"
let-rateProfile>
<tr [pSelectableRow]="rateProfile">
  @for (col of columns; track col) {
    <td>{{rateProfile[col.field]}}</td>
  }
</tr>
</ng-template> <ng-template pTemplate="paginatorleft"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template> </p-table>
